import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { SortMenu } from '../../shared/models/sort-menu';
import { FilterMenu } from '../../shared/models/filter-menu';
import { PanelList } from '../../shared/models/panel-list';
import { DocumentSearchResult } from '../../document/models/documentSearchResult';
import { DatePipe, NgStyle } from '@angular/common';
import { PhaseNamesConstant } from '../../shared/constants/phaseNames-constants';
import { DocumentService } from '../../../app/document/services/document.service';
import { PhaseValueConstants } from '../../../app/shared/constants/phaseValues-constants';
import { AssignmentGroupSharedDataService } from '../../../app/shared/services/assignment-group-shared-data.service';
import { DocumentLibraryConstants } from '../../../app/document/document-library-constants';
import { DocumentReadAudit } from '../../document/models/document-read-audit';
import { DocumentPanelListConstants } from './constants/documents-panel-list.contants';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { MenuItem, MessageService } from 'primeng/api';
import { CommonService } from '../../shared/services/common.service';
import { DefaultFilter } from '../../shared/models/panel-list/default-filter';
import { SharedConstants } from '../../../app/shared/constants/shared-constants';
import { DocumentSearchService } from '../../../app/shared/services/document-search.service';
import { PanelListComponent } from '../../../app/shared/components/panel-list/panel-list.component';
import { IEQMSScopeLookUpDetails } from '../../../app/shared/models/scopes/eqms-Scope-lookup-details';
import { PanelCardView } from '../../shared/enums/panelCardView';
import { DocumentPersistenceService } from '../../document/services/document-persistence.service';
import { PanelListPersistenceService } from '../../shared/services/panel-list-persistence.service';
import { UserAssignmentDetail } from '../../shared/models/users/user-assignment-detail';

@Component({
  selector: 'app-documents-panel-list',
  templateUrl: './documents-panel-list.component.html',
  styleUrls: ['./documents-panel-list.component.scss'],
})
export class DocumentsPanelListComponent implements OnInit, OnChanges {
  @Input() documentSearchResult: DocumentSearchResult[] | undefined = undefined;
  @Input() isShowCheckbox = false;
  @Input() selectCheckbox = false;
  @Input() showInformationIconCheckbox = false;
  @Input() showLoader: boolean = false;
  @Input() informationIconTooltip:string|undefined = undefined;
  @Input() isSearch = false;
  @Input() isExportButtonAvailable=true;
  @Input() defaultFiltersSelected: DefaultFilter[] = [];
  @Output() checkboxSelection = new EventEmitter();
  @Input() displayDocumentSelectCheckBoxes:boolean = true;
  @Input() enableFavoriteButton:boolean = false;
  @Input() enableInactiveLabel:boolean = false;
  @Input() checkboxLabel:string = "Show Inactive";
  @Input() myPanelListType:string = "Document";
  @Input() panelDataSource!:string;
  @Input() panelListScreen!:string;
  @Input() enableToaster: boolean = true;

  noData: boolean = false;
  isExportButtonAvailableForUser:boolean=false;
  documentLookUpData:any;
  isPanelListDataAvailable = false;
  panelCardViewType ?: number
  showPanelCard : boolean = false
  defaultView : number = PanelCardView.DefaultView;
  assignmentView : number = PanelCardView.AssignmentView;
  whereAmIUsedView : number = PanelCardView.WhereAmIUsedView;
  readOnlyFileUrl: string = '';
  openPdfPreviewModal : boolean = false;
  
  documentsPanelListData: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableSelection: true,
    enableToggling: true,
    enableExport: false,
    enablePanelCardView:false,
    enableAssignmentView : false,
    enableWhereAmIUsedView:true
  };

  myFavoritePanelList: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableSelection: false,
    enableToggling: true,
  };

  @Output() selectedItems = new EventEmitter();
  fileId!:string;
  fileName!:string;
  cancelledDocumentPhaseConstant:any=PhaseValueConstants.Cancelled;
  displayAssignedQas : number = DocumentPanelListConstants.PanelList_DisplayAssignedQas;
  displayAssignedDocControls : number = DocumentPanelListConstants.PanelList_DisplayAssignedDocControls;
  displayCollaborators : number = DocumentPanelListConstants.PanelList_DisplayCollaborators
  displayAssignedAdmin : number = DocumentPanelListConstants.PanelList_DisplayAssignedAdmin;
  displayApprovers : number = DocumentPanelListConstants.PanelList_DisplayApprovers;
  displayReviewers: number = DocumentPanelListConstants.PanelList_DisplayReviewers;
  displayInternalClientContacts: number = DocumentPanelListConstants.PanelList_DisplayInternalClientContacts;
  initialized: boolean = false;
  assignedQaList: string[] = []
  @ViewChild(PanelListComponent) 
  private panelListComponent! : PanelListComponent; 

  constructor(private datePipe: DatePipe,
    private documentsservice: DocumentService,
    private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private messageService:MessageService,
    private commonService: CommonService,
    private documentSearchService:DocumentSearchService,
    private documentPersistenceService : DocumentPersistenceService,
    private panelListPersistenceService : PanelListPersistenceService
  ) { }

  ngOnInit(): void {
    this.setPanelList();  
    this.initialized = true;  
  }

  ngOnChanges() {
    if (!this.initialized) { return; }
    this.setPanelList();
  }

  setPanelList() {
    this.documentsPanelListData = this.displayDocumentSelectCheckBoxes ?  this.documentsPanelListData  : this.myFavoritePanelList;
    this.documentsPanelListData.clearSelection = true; //Resetting the selected documents
    // Below two line of code is get the filters dynamically based on Queue and also its values as strings
    const propertyName = this.getPropertyNameByPanelType(this.myPanelListType);
    this.documentsPanelListData.lists = this.assignmentGroupSharedDataService.getPanelListDataWithProperty(this.documentSearchResult, propertyName);    
    this.documentsPanelListData.enableExport= this.isExportButtonAvailable && this.panelDataSource === SharedConstants.Document_Library_Panel_List_Data_Source;
    this.documentsPanelListData.enablePanelCardView = this.myPanelListType === DocumentLibraryConstants.DocLibrary_PanelListType
    this.documentsPanelListData.enableAssignmentView = this.myPanelListType === DocumentLibraryConstants.DocLibrary_PanelListType
    this.documentsPanelListData.enableWhereAmIUsedView = this.myPanelListType === DocumentLibraryConstants.DocLibrary_PanelListType
    this.noData = this.commonService.IsListEmpty(this.documentsPanelListData.lists);
    this.updateeQMSScopeData();
    if(this.documentSearchResult != undefined){
      if(this.panelListScreen == this.documentPersistenceService.panelListScreen){
        this.documentPersistenceService.panelListView$.subscribe(value=>{
          this.panelCardViewType = value;
          if(this.panelCardViewType == PanelCardView.AssignmentView){
            this.setFiltersAndSortByForAssignmentView();
          }
          if(this.panelCardViewType == PanelCardView.DefaultView){
            this.setFiltersAndSortBy();
          }
          if(this.panelCardViewType == PanelCardView.WhereAmIUsedView)
          {
            this.setFiltersAndSortByForWhereAmIUsedView();
          }
        })
      }
      else{
        this.panelCardViewType = this.defaultView;
        this.setFiltersAndSortBy();
        this.documentPersistenceService.updatePanelListView(PanelCardView.DefaultView)
      }
    }
  }
  checkPanelCardViewType(event:PanelCardView){
    this.panelCardViewType = event
    this.showPanelCard = false;
    this.documentPersistenceService.updatePanelListView(event);
  }

  switchPanelCardView(){
    // reset selected documents if any
    this.clearSelection();

    if(this.panelCardViewType == PanelCardView.DefaultView){
      this.panelListComponent.clearAllFilters();
      this.setFiltersAndSortBy();
      this.documentPersistenceService.updatePanelListView(PanelCardView.DefaultView);
    }
    else if(this.panelCardViewType == PanelCardView.AssignmentView){
      this.panelListComponent.clearAllFilters();
      this.setFiltersAndSortByForAssignmentView();
      this.documentPersistenceService.updatePanelListView(PanelCardView.AssignmentView);
    }
    else if(this.panelCardViewType == PanelCardView.WhereAmIUsedView){
      this.panelListComponent.clearAllFilters();
      this.setFiltersAndSortByForWhereAmIUsedView();
      this.panelListPersistenceService.updatePanelListView(PanelCardView.WhereAmIUsedView);
    }
    this.documentPersistenceService.updateScreenType(this.panelListScreen);
  }

  setFiltersAndSortBy(){
    this.showPanelCard=true;
    this.documentsPanelListData.filters = this.getFiltersForDocumentPanelList();
    this.documentsPanelListData.sort = this.getSortFieldsForForDocumentPanelList();
  }


  setFiltersAndSortByForWhereAmIUsedView(){
    this.showPanelCard=true;
    this.documentsPanelListData.filters = this.getFiltersForWhereAmIUsedView();
    this.documentsPanelListData.sort = this.getSortFieldsForWhereAmIUsedView();
  }



  getFiltersForWhereAmIUsedView = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'eQMS Scope(s)',
        filterFieldName: 'eQMSScopeDisplayNames',
      },
      {
        filterDisplayName: 'Curriculum(s)',
        filterFieldName: 'curriculumScopeNames',
      },
      {
        filterDisplayName: 'Training Item Group(s)',
        filterFieldName: 'trainingItemGroupNames',
      },
      {
        filterDisplayName:'Related Document(s)',
        filterFieldName:'relatedDocumentsNames'
      }
    );
    return filters;
  };
  getSortFieldsForWhereAmIUsedView = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'eQMS Scope(s)',
        sortFieldName: 'eQMSScopeDisplayNames'
      },
      {
        sortFieldDisplayName: 'Curriculum(s)',
        sortFieldName:'curriculumScopeNames'
      },
      {
        sortFieldDisplayName: 'Training Item Group(s)',
        sortFieldName: 'trainingItemGroupNames'
      },
      {
        sortFieldDisplayName: 'Related Document(s)',
        sortFieldName: 'relatedDocumentsNames'
      }
    );
    return sortMenu;
  };

  setFiltersAndSortByForAssignmentView(){
    this.showPanelCard=true;
    this.setFilterandSortByName(DocumentLibraryConstants.QaReview_PanelListType);
    this.setFilterandSortByName(DocumentLibraryConstants.DocCollaborator_PanelListType);
    this.setFilterandSortByName(DocumentLibraryConstants.DocFormattings_PanelListType);
    this.setFilterandSortByName(DocumentLibraryConstants.InternalClientContacts_PanelListType);
    this.documentsPanelListData.filters = this.getFiltersForAssignmentView();
    this.documentsPanelListData.sort = this.getSortFieldsForAssignmentView();
  }

  setFilterandSortByName(fieldName : string){
    const propertyName = this.getPropertyNameByPanelType(fieldName);
    this.documentsPanelListData.lists = this.assignmentGroupSharedDataService.getPanelListDataWithProperty(this.documentsPanelListData.lists, propertyName);
  }

  getPropertyNameByPanelType(panelType: string): string {
    switch (panelType) {      
      case DocumentLibraryConstants.DocApprovals_PanelListType:
        return DocumentLibraryConstants.DocApprovals_PanelListType;
      case DocumentLibraryConstants.QaReview_PanelListType:
        return DocumentLibraryConstants.QaReview_PanelListType;
      case DocumentLibraryConstants.DocFormattings_PanelListType:
        return DocumentLibraryConstants.DocFormattings_PanelListType;
      case DocumentLibraryConstants.DocCollaborator_PanelListType:
        return DocumentLibraryConstants.DocCollaborator_PanelListType;
      case DocumentLibraryConstants.InternalClientContacts_PanelListType:
        return DocumentLibraryConstants.InternalClientContacts_PanelListType;
      default:
        return DocumentLibraryConstants.AssignedAdmin_PanelListType;
    }
  }

  getSelectedItems(selectedItemsData: DocumentSearchResult[]) {
    this.selectedItems.emit(selectedItemsData);
  }

  checkboxSelectionChange(){
    this.checkboxSelection.emit(this.selectCheckbox);
  }

  downloadSourceFile(number:any,version:any, phase:string, printLock:boolean = false) {

    if(phase === "0" || phase === "1" || phase === "2"){
      this.documentsservice.getDocumentSourceFile(number, version)
      .subscribe({next:(documentSourceFile: { fileId: string; name: string; })=>{
        this.fileId=documentSourceFile.fileId;
        this.fileName=documentSourceFile.name;
        this.downloadFile(number,version,'',false);
      },error:(error)=>{
        if(error.status === 401){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: `${error.error}`,
          })
        }
        else{
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
            sticky: true
          })
        }
      }})
    }else if(phase !== "8"){
      this.documentsservice.getDocumentDetailsForDocumentFormattedFile(number, version).subscribe({next:(documentFormattedFile: { fileId: string; name: string;fileType:string })=>{
        this.fileId=documentFormattedFile.fileId;
        this.fileName=documentFormattedFile.name;
        this.downloadFile(number,version,documentFormattedFile.fileType,printLock);
      },error:(error)=>{
        if(error.status === 401){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: `${error.error}`,
          })
        }
        else{
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
            sticky: true
          })
        }
      }})
    }
  }
  downloadFile(number:string,version:number,fileFormat: string,printLock:boolean) {
     this.documentsservice.downloadFile(this.fileId).subscribe(
      {next:(response: { fileUri: any; }) => {
        if ((fileFormat === ".pdf" || fileFormat === ".PDF") && printLock) { 
          this.readOnlyFileUrl = response.fileUri;
          this.openPdfPreviewModal = true;
        } else {
          let downloadLink = document.createElement('a');
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute('style', 'display: none');
          downloadLink.href = response.fileUri;
          downloadLink.download = this.fileName;
          downloadLink.target = '_blank';
          downloadLink.click();
          downloadLink.remove();
        }
  },
  error:()=>{
    if(this.fileId != undefined || this.fileId != null){
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: DocumentLibraryConstants.Document_File_UnableToDownload,
        sticky: true
      })
    }
    else{
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
        sticky: true
      })
    }
}});
    this.addAuditForDocumentReadActivity(number,version);
  }
  calculateToolTip = (attributes : UserAssignmentDetail[]) : string => {
    let tooltip : string ="";
     attributes.forEach(attribute => {
      tooltip =tooltip.concat(attribute.name, ", ");
    })
     return tooltip.slice(0,-2);
     }
  getFiltersForDocumentPanelList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Phase',
        filterFieldName: 'phaseName',
      },
      {
        filterDisplayName: 'Sub-BU',
        filterFieldName: 'responsibleSubBU',
      },
      {
        filterDisplayName: 'Category',
        filterFieldName: 'category',
      },
      {
        filterDisplayName: 'Type',
        filterFieldName: 'documentType',
      },
      {
        filterDisplayName: 'Legacy Document #',
        filterFieldName: 'legacyDocumentNumber',
      },
      {
        filterDisplayName: 'Local Category',
        filterFieldName: 'localCategory',
      },
      {
        filterDisplayName: 'Local Type',
        filterFieldName: 'localType',
      },
      {
        filterDisplayName: 'Assigned Admin(s)',
        filterFieldName: 'assignedAdminsList',
      },
      {
        filterDisplayName: 'eQMS Scope',
        filterFieldName: 'eQMSScopeDisplayNames',
      }
    );
    if(this.myPanelListType == DocumentLibraryConstants.ChangeRequest_PanelListType){
      filters.splice(3, 0,  {
        filterDisplayName: 'CR Type',
        filterFieldName: 'changeRequestItemType',
      });
      filters.splice(4, 0,  {
        filterDisplayName: 'Requested By',
        filterFieldName: 'requestedBy',
      });
    }

    if(this.myPanelListType == DocumentLibraryConstants.DocApprovals_PanelListType){
      filters.splice(7, 1, {
        filterDisplayName: 'Approver(s)',
        filterFieldName: 'approvers'
      })
    }

    if(this.myPanelListType == DocumentLibraryConstants.QaReview_PanelListType){     
      filters.splice(7, 1, {
        filterDisplayName: 'Assigned QA(s)',
        filterFieldName: 'assignedQasList'
      })
    }

    if(this.myPanelListType == DocumentLibraryConstants.DocFormattings_PanelListType){     
      filters.splice(7, 1, {
        filterDisplayName: 'Assigned Doc Control(s)',
        filterFieldName: 'assignedDocControlsList'
      })
    }

    if(this.myPanelListType == DocumentLibraryConstants.DocCollaborator_PanelListType){
      filters.splice(7, 1, {
        filterDisplayName: 'Collaborator(s)',
        filterFieldName: 'collaboratorsList'
      })
    }
    if(this.myPanelListType == DocumentLibraryConstants.InternalClientContacts_PanelListType){
      filters.splice(7, 1, {
        filterDisplayName: 'Internal Client Contact(s)',
        filterFieldName: 'internalClientContactsList'
      })
    }

    return filters;
  };

  getFiltersForAssignmentView = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Phase',
        filterFieldName: 'phaseName',
      },
      {
        filterDisplayName: 'Author',
        filterFieldName: 'author',
      },
      {
        filterDisplayName: 'Assigned Admin(s)',
        filterFieldName: 'assignedAdminsList',
      },
      {
        filterDisplayName: 'Collaborator(s)',
        filterFieldName: 'collaboratorsList'
      },
      {
        filterDisplayName: 'Assigned QA(s)',
        filterFieldName: 'assignedQasList'
      },
      {
        filterDisplayName: 'Assigned Doc Control(s)',
        filterFieldName: 'assignedDocControlsList'
      },
      {
        filterDisplayName: 'Reviewer(s)',
        filterFieldName: 'reviewers',
      },
      {
        filterDisplayName: 'Approver(s)',
        filterFieldName: 'approvers'
      },
      {
        filterDisplayName: 'Periodic Reviewer(s)',
        filterFieldName: 'periodicReviewers'
      },
      {
        filterDisplayName: 'Internal Client Contact(s)',
        filterFieldName: 'internalClientContactsList'
      }
    );
    return filters;
  }


  getSortFieldsForForDocumentPanelList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Title',
        sortFieldName: 'title',
      },
      {
        sortFieldDisplayName: 'Phase',
        sortFieldName: 'phase',
      },
      {
        sortFieldDisplayName: 'Sub-BU',
        sortFieldName: 'responsibleSubBU',
      },
      { sortFieldDisplayName: 'Category', sortFieldName: 'category' },
      { sortFieldDisplayName: 'Type', sortFieldName: 'documentType' },
      { sortFieldDisplayName: 'Local Category', sortFieldName: 'localCategory' },
      { sortFieldDisplayName: 'Local Type', sortFieldName: 'localType' },
      {
        sortFieldDisplayName: 'Assigned Admin(s)',
        sortFieldName: 'assignedAdminsList',
      },
      { sortFieldDisplayName: 'eQMS Scope', sortFieldName: 'eQMSScopeDisplayNames' },
      { sortFieldDisplayName: 'Next Review Date', sortFieldName: 'nextReviewDate' },
      { sortFieldDisplayName: 'Requested Effective Date', sortFieldName: 'requestedEffectiveDate'},
    );
    if(this.myPanelListType == DocumentLibraryConstants.ChangeRequest_PanelListType){
      sortMenu.push(
        { sortFieldDisplayName: 'CR Type', sortFieldName: 'changeRequestItemType' },
        { sortFieldDisplayName: 'Requested By', sortFieldName: 'requestedBy' },  
      );
    }

    if(this.myPanelListType == DocumentLibraryConstants.DocLibrary_PanelListType){
      sortMenu.push(
        { sortFieldDisplayName: 'Effective Date', sortFieldName: 'effectiveDate'}
      )
    }

    if(this.myPanelListType == DocumentLibraryConstants.DocApprovals_PanelListType){
      sortMenu.splice(7, 1, {
        sortFieldDisplayName: 'Approver(s)',
        sortFieldName: 'approvers'
      })
    }

    if(this.myPanelListType == DocumentLibraryConstants.QaReview_PanelListType){     
      sortMenu.splice(7, 1, {
        sortFieldDisplayName: 'Assigned QA(s)',
        sortFieldName: 'assignedQasList'
      })
    }

    if(this.myPanelListType == DocumentLibraryConstants.DocFormattings_PanelListType){     
      sortMenu.splice(7, 1, {
        sortFieldDisplayName: 'Assigned Doc Control(s)',
        sortFieldName: 'assignedDocControlsList'
      })
    }

    if(this.myPanelListType == DocumentLibraryConstants.DocCollaborator_PanelListType){
      sortMenu.splice(7, 1, {
        sortFieldDisplayName: 'Collaborator(s)',
        sortFieldName: 'collaboratorsList'
      })
    }
    if(this.myPanelListType == DocumentLibraryConstants.InternalClientContacts_PanelListType){
      sortMenu.splice(7, 1, {
        sortFieldDisplayName: 'Internal Client Contact(s)',
        sortFieldName: 'internalClientContactsList'
      })
    }

    return sortMenu;
  };

  getSortFieldsForAssignmentView = (): SortMenu[] => {
    let filters: SortMenu[] = [];
    filters.push(
      {
        sortFieldDisplayName: 'Phase',
        sortFieldName: 'phase',
      },
      {
        sortFieldDisplayName: 'Author',
        sortFieldName: 'author',
      },
      {
        sortFieldDisplayName: 'Assigned Admin(s)',
        sortFieldName: 'assignedAdminsList',
      },
      {
        sortFieldDisplayName: 'Collaborator(s)',
        sortFieldName: 'collaboratorsList'
      },
      {
        sortFieldDisplayName: 'Assigned QA(s)',
        sortFieldName: 'assignedQasList'
      },
      {
        sortFieldDisplayName: 'Assigned Doc Control(s)',
        sortFieldName: 'assignedDocControlsList'
      },
      {
        sortFieldDisplayName: 'Reviewer(s)',
        sortFieldName: 'reviewers'
      },
      {
        sortFieldDisplayName: 'Approver(s)',
        sortFieldName: 'approvers'
      },
      {
        sortFieldDisplayName: 'Periodic Reviewer(s)',
        sortFieldName: 'periodicReviewers'
      },
      {
        sortFieldDisplayName: 'Internal Client Contact(s)',
        sortFieldName: 'internalClientContactsList'
      }
    );
    return filters;
  }

  openDocument(documentNumber: string, version: string) {
    var url = location.origin.concat("/eqms.documentDetails/", documentNumber, ":", version);
    window.open(url, "_blank");
  }

  displayPhaseLabelWithDate = (phase: number, effectiveDate: Date, requestedEffectiveDate: Date): string => {
    let displayData = '';
    switch (Number(phase)) {
      case 0:
        displayData = PhaseNamesConstant.Collaboration;
        break;
      case 1:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.QaReview + ' (' + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") +')': PhaseNamesConstant.QaReview;
        break;
      case 2:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.Formatting + ' ('+  this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") +')': PhaseNamesConstant.Formatting;
        break;
      case 3:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.InReview + ' (' + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") + ')': PhaseNamesConstant.InReview;
        break;
      case 4:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.ReadyForApproval + ' ('  + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy")+ ')' : PhaseNamesConstant.ReadyForApproval;
        break;
      case 5:
        displayData = effectiveDate != null ? PhaseNamesConstant.Approved + ' (' + this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')': PhaseNamesConstant.Approved;
        break;
      case 6:
        displayData = effectiveDate != null ? PhaseNamesConstant.Effective + ' ('+ this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.Effective;
        break;
      case 7:
        displayData = effectiveDate != null ? PhaseNamesConstant.Archived + ' (' + this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')': PhaseNamesConstant.Archived;
        break;
      case 8:
        displayData = PhaseNamesConstant.Cancelled;
        break;
      case 9:
        displayData = effectiveDate != null ? PhaseNamesConstant.Obsolete + ' ('+ this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')': PhaseNamesConstant.Obsolete;
        break;
      case 10:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.ClientSignature + ' ('+  this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") +')': PhaseNamesConstant.ClientSignature;
        break;
    }
    return displayData;
  };

  calculatePhaseColor = (phase: number): string => {
    let statusColor = '';
    switch (Number(phase)) {
      case 0:
        statusColor = 'collaboration';
        break;
      case 1:
        statusColor = 'q_a_review';
        break;
      case 2:
        statusColor ='formatting';
        break;
      case 3:
        statusColor ='in_review';
        break;
      case 4:
        statusColor ='ready_for_approval';
        break;
      case 5:
        statusColor ='approved';
        break;
      case 6:
        statusColor ='effective';
        break;
      case 7:
        statusColor ='archived';
        break;
      case 8:
        statusColor = 'cancelled';
        break;
      case 9:
        statusColor ='obsolete';
        break;
        case 10:
          statusColor ='client_signature';
          break;
    }
    return statusColor;
  };

clearSelection(){
  this.documentsPanelListData.clearSelection = true;
    this.documentsPanelListData = { ...this.documentsPanelListData };
}

updateDocumentFavourite(documentNumber: string){
  this.documentsservice.updateDocumentFavorite(documentNumber).subscribe();
  this.documentsPanelListData.lists = this.documentsPanelListData.lists.filter((data: any) => data.documentNumber !== documentNumber);
}

getFavoriteToolTip(){
  return DocumentLibraryConstants.ToolTipMessage_ToRemoveFromFavorite ;
}
addAuditForDocumentReadActivity = (number:string,version:number) => {
  let documentReadAuditDto: DocumentReadAudit = {
    documentNumber: number,
    documentVersion: version,
    attributeName: "Document Source File"
  };
  this.documentsservice.addAuditForDocumentRead(documentReadAuditDto).subscribe();
}

updateeQMSScopeData(){

  this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes)=>{
    this.documentsPanelListData.lists.forEach((documentDetail: {
      eQMSScopeDisplayNames: string[]; eQMSScope: number[]; 
})=>{
      documentDetail.eQMSScopeDisplayNames = [];
      documentDetail.eQMSScope.forEach((eQMSScopeData : number)=>{
        let eQMSScope = eQMSScopes.filter((e: { eQMSScopeId: number; }) => {return e.eQMSScopeId === eQMSScopeData});
        if(documentDetail.eQMSScopeDisplayNames === undefined 
          || documentDetail.eQMSScopeDisplayNames === null) 
          documentDetail.eQMSScopeDisplayNames = [];
          documentDetail.eQMSScopeDisplayNames?.push(eQMSScope[0].eQMSScopeName);
      })
    })
    this.documentsPanelListData.filters = this.getFiltersForDocumentPanelList();
    this.documentsPanelListData.sort =  this.getSortFieldsForForDocumentPanelList();
    this.documentsPanelListData = { ...this.documentsPanelListData }
    this.isPanelListDataAvailable = true;
  });
}
exportExcel = () => {
  let filters=this.panelListComponent.getFiltersAndSortDetails();
  let eqmsScopeFilterIndex = filters.filterDetails?.findIndex(object => {
    return object.fieldName === "eQMSScopeDisplayNames";
  });
  let eQMSScopesList : IEQMSScopeLookUpDetails[]=[];
  let eQMSScopeIds: string[]=[];
if(eqmsScopeFilterIndex!== undefined && eqmsScopeFilterIndex!==-1)
{
  this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes)=>{
     eQMSScopesList = eQMSScopes
    });
    filters.filterDetails[eqmsScopeFilterIndex].fieldValues.forEach(item=>{
      let eqmsScopeId=eQMSScopesList.find(i=> i.eQMSScopeName.toLowerCase() === item.toLocaleLowerCase())?.eQMSScopeId;
      if(eqmsScopeId!==undefined)
        eQMSScopeIds.push(eqmsScopeId.toString());
    })
    filters.filterDetails[eqmsScopeFilterIndex].fieldValues=eQMSScopeIds;
}
  this.documentSearchService.exportToExcel(filters);
  this.panelListComponent.getDefaultFilterAndSortDetails();
}

openCurriculum(curriculumScopeId: number) {
  var url = location.origin.concat(`/eqms.curriculum/curriculumLinkout?scopeId=${curriculumScopeId}&&isLinkout=true`);
  window.open(url, "_blank");
}  

openTrainingItemGroup(trainingItemGroupNumber: string) {
  var url = location.origin.concat(`/eqms.training-item/trainingItemGroupLinkout?trainingItemGroupNumber=${trainingItemGroupNumber}&&isLinkout=true`);
  window.open(url, "_blank");
}  

openRelatedDocument(number: string, documentVersion:number, documentType:number) {
  if(documentType === DocumentLibraryConstants.DocumentType_RelatedDocument)
  {
    var documentUrl = location.origin.concat(`/eqms.documentDetails/${number}:${documentVersion}`);
    window.open(documentUrl, "_blank");
  }
  else if(documentType === DocumentLibraryConstants.CourseType_RelatedDocument)
  {
    var courseUrl = location.origin.concat(`/training/eqms.courses/${number}`);
    window.open(courseUrl, "_blank");
  }
}  
showPdfPreviewModal(isModalShow:boolean) :void {
   this.openPdfPreviewModal = isModalShow;
}
}



